export default {
  state: () => ({
    allAuthorsList: [], // 所有作者清單（GET /authors）
    authorAppList: {}, // memberId → 該作者的 APP 清單，作為 GET /apps/{id} 的快取
  }),
  getters: {
    allAuthorsList(state) {
      return state.allAuthorsList;
    },
    authorAppList(state) {
      return state.authorAppList;
    },
  },
  mutations: {
    UPDATE_ALL_AUTHORS_LIST(state, payload) {
      state.allAuthorsList = payload.allAuthorsList;
    },
    UPDATE_AUTHOR_APP_ITEM(state, payload) {
      // 換整個物件，讓 Vue 2 能追蹤新增的 memberId key
      state.authorAppList = {
        ...state.authorAppList,
        [payload.memberId]: payload.appList,
      };
    },
  },
  actions: {
    updateAllAuthorsList({ commit }, payload) {
      commit('UPDATE_ALL_AUTHORS_LIST', payload);
    },

    updateAuthorAppItem({ commit }, payload) {
      commit('UPDATE_AUTHOR_APP_ITEM', payload);
    },
  },
};
